import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { throttle } from "throttle-debounce";
// eslint-disable-next-line import/no-cycle
import { BrandsCarousel } from "../../components/HotelBrands/BrandsCarousel/BrandsCarousel";

const HotelChainsCarouselConnector = ({ data }) => {
	let hotels = data.hotelChains.nodes ?? [];
	const [entriesPerPageByViewPort, setEntriesPerPageByViewPort] = useState(18);
	useEffect(() => {
		const updateEntriesPerPage = () => {
			const isMobile = window.matchMedia("(max-width: 567px)").matches;
			const isTablet =
				window.matchMedia("(min-width: 567.9px)").matches &&
				window.matchMedia("(max-width: 991.99px)").matches;

			if (isMobile) {
				setEntriesPerPageByViewPort(6);
			} else if (isTablet) {
				setEntriesPerPageByViewPort(9);
			} else {
				setEntriesPerPageByViewPort(18);
			}
		};

		const throttledResize = throttle(150, updateEntriesPerPage);

		updateEntriesPerPage();
		window.addEventListener("resize", throttledResize);

		return () => {
			window.removeEventListener("resize", throttledResize);
			throttledResize.cancel?.();
		};
	}, []);

	const alphabetizedHotels = hotels
		?.filter(hotel => !hotel.hotelChainPriority)
		?.sort((a, b) => a?.chainName?.localeCompare(b?.chainName));

	const priorityHotels = hotels
		?.filter(hotel => hotel.hotelChainPriority)
		?.sort((a, b) => a?.hotelChainPriority - b?.hotelChainPriority);

	const sortedHotels = [...priorityHotels, ...alphabetizedHotels];
	const slides = [];

	for (let i = 0; i < sortedHotels.length; i += entriesPerPageByViewPort) {
		slides.push(sortedHotels.slice(i, i + entriesPerPageByViewPort));
	}

	return (
		<BrandsCarousel
			slides={slides}
			totalItem={sortedHotels.length}
			entriesPerPage={entriesPerPageByViewPort}
		/>
	);
};

HotelChainsCarouselConnector.propTypes = {
	data: PropTypes.object.isRequired,
};

export const query = graphql`
	query GetAllLocalizedHotelChains($locale: String!) {
		hotelChains: allContentfulHotelChain(filter: { node_locale: { eq: $locale } }) {
			nodes {
				id
				node_locale
				chainName
				slug
				hotelChainPriority
				logo {
					secure_url
					width
					height
					raw_transformation
					version
					public_id
					format
				}
			}
		}
	}
`;

export default HotelChainsCarouselConnector;
export { HotelChainsCarouselConnector };
